import {Component} from '@angular/core';
import {AlertController, NavController, LoadingController} from 'ionic-angular';
import {InAppBrowser} from '@ionic-native/in-app-browser';
import {MembershipService} from './membership.service';
import {AuthService} from './../../../../services/auth';
import {SessionService} from './../../../../services/session';
import {LocationsService} from './../../../../services/locations';
import {BackendModule} from './../../../../modules/backend.module';
import {NewMembershipPage} from './new-membership/new-membership';
import {UpdateMembershipPage} from './update-membership/update-membership';


@Component({
  selector: 'page-membership',
  templateUrl: 'membership.html'
})
export class MembershipPage {

  newMembershipPage = NewMembershipPage;
  updateMembershipPage = UpdateMembershipPage;


  constructor(private iab: InAppBrowser,
              public backendModule: BackendModule,
              public alertCtrl: AlertController,
              public sessionService: SessionService,
              public membershipService: MembershipService,
              public navCtrl: NavController,
              public authService: AuthService,
              public loadingCtrl: LoadingController,
              public locationsService: LocationsService) {
  }

  goTo(page) {
    this.navCtrl.push(page)
  }

  select(planIndex) {
    this.membershipService.selectPlan(planIndex);
    this.navCtrl.push(this.newMembershipPage)
  }

  // Splits a plan `info` string into individual bullet features.
  // The backend sends a single sentence-joined paragraph; we break it on
  // sentence boundaries so the grid tiles can render a checkmark list.
  planFeatures(info: string): string[] {
    if (info == null) {
      return [];
    }
    return info
      .split(/\.\s+/)
      .map(feature => feature.replace(/\.\s*$/, '').trim())
      .filter(feature => feature.length > 0);
  }

  // True for the last tile when there is an odd number of plans, so the
  // grid can center the lone tile instead of leaving an empty cell.
  isOrphan(index: number): boolean {
    const len = this.membershipService.plans ? this.membershipService.plans.length : 0;
    return len % 2 === 1 && index === len - 1;
  }

  // Tier label pill: "Paquete" for the 10-reservation packs, "Ilimitado" for monthly plans.
  planBadge(plan): string {
    const name = (plan && plan.name) ? plan.name.toLowerCase() : '';
    return name.indexOf('10 pack') !== -1 ? 'Paquete' : 'Ilimitado';
  }

  // Color tier mapped by plan identity (not array order, which varies by account).
  planTier(plan): string {
    const name = (plan && plan.name) ? plan.name.toLowerCase() : '';
    if (name.indexOf('10 pack') !== -1) {
      return name.indexOf('classic') !== -1 ? 'tier-pack-classic' : 'tier-pack-pro';
    }
    return name.indexOf('pro') !== -1 ? 'tier-pro' : 'tier-classic';
  }

  showCancelMembershipAlert() {
    let returnButton = {
      text: 'No, regresar',
      role: 'cancel',
    };

    let pauseButton = {
      text: 'Congelar Membresía',
      handler: () => {
        this.showPauseMembershipAlert();
      }
    };

    let cancelButton = {
      text: 'Sí, cancelar membresía',
      cssClass: 'red-cancel-button',
      handler: () => {
        this.cancelMembership();
      }
    };

    let buttons = this.membershipService.user_can_pause ?
      [returnButton, pauseButton, cancelButton] :
      [returnButton, cancelButton];

    let alert = this.alertCtrl.create({
      title: 'Cancelar membresía',
      message: '¿Estás seguro que deseas cancelar tu membresía?',
      buttons: buttons
    });
    alert.present();
  }

  showPauseMembershipAlert() {
    let alert = this.alertCtrl.create({
      title: 'Congelar membresía',
      message: this.membershipService.user_pause_info || '¿Estás seguro que deseas congelar tu membresía?',
      buttons: [
        {
          text: 'No, regresar',
          role: 'cancel',
        },
        {
          text: 'Sí, congelar membresía',
          cssClass: 'red-cancel-button',
          handler: () => {
            this.pauseMembership()
          }
        }
      ]
    });
    alert.present();
  }

  pauseMembership() {
    let errorMsg = 'Error al congelar membresía, inténtalo más tarde';
    let successMsg = 'Tu membresía se ha congelado de forma exitosa';
    let infoMsg = 'Cualquier duda: ' + this.locationsService.translate('infoMail');
    let loading = this.loadingCtrl.create();
    loading.present();

    /**
    this.conektaService.pause().subscribe(
      (res: any) => {
        this.authService.getUserInfo(this.sessionService.user.id);
        let alert = this.alertCtrl.create({
          title: res.paused ? successMsg : errorMsg,
          message: infoMsg,
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
            },
          ]
        });
        loading.dismiss();
        alert.present();
      },
      err => {
        this.sessionService.reportError(
          'membershipPage',
          'pauseMembership()',
          err
        );
        // older TS version so cannot do err.error?.error || infoMsg
        const hasErrorMessage = err.error && err.error.error;
        const message = hasErrorMessage ? err.error.error : infoMsg;
        let errorAlert = this.alertCtrl.create({
          title: errorMsg,
          message,
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
            },
          ]
        });
        loading.dismiss();
        errorAlert.present();
      }
    )
      */
  }

  cancelMembership() {
    const loading = this.loadingCtrl.create();
    loading.present();

    this.membershipService.cancelMembership().subscribe(
      () => {
        this.authService.getUserInfo(this.sessionService.user.id);
        const alert = this.alertCtrl.create({
          title: 'Se canceló correctamente tu membresía',
          message: 'Podrás seguir utilizando tu membresía hasta tu fecha de ' +
            this.locationsService.translate('expiry'),
          buttons: [{text: 'OK', role: 'cancel',}],
        });

        loading.dismiss()
          .then(() => alert.present());
      },
      err => {
        this.sessionService.reportError(
          'membershipsPage',
          'cancelMembership()',
          err
        );

        const alert = this.alertCtrl.create({
          title: 'Error al cancelar, inténtalo más tarde',
          message: err.error.errors.general[0] || 'Cualquier duda: ' + this.locationsService.translate('infoMail'),
          buttons: [
            {
              text: 'OK',
              role: 'cancel',
            },
          ]
        });

        loading.dismiss()
          .then(() => alert.present());
      }
    )
  }

  openBrowser(url) {
    this.iab.create(url, '_blank');
  }

  ionViewDidLoad() {
    window['page'] = 'MembershipPage'; // for GA
  }
}



// WEBPACK FOOTER //
// ./src/pages/tabs/profile/membership/membership.ts